import React from 'react';
import Image from 'next/image';

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    text: string | any;
    inactive?: boolean;
    refer?: React.MutableRefObject<null>;
    icon?: string;
    background?: string;
}

const MainButton = ({ text, className, inactive, refer, icon, background, ...props }: Props) => {
    return (
        <button
            style={background ? { backgroundColor: background } : {}}
            className={`flex items-center gap-2 font-semibold px-3 py-2 rounded-lg justify-center shrink-0 ${className}`}
            {...props}
        >
            {icon && <Image width={18} height={18} src={icon} alt={text} />}
            {text}
        </button>
    );
};

export default MainButton;
